export default function (handler) {
    if (window.requestAnimationFrame) {
        let requested = false;
        // Discarding possible arguments for simplicity, our event handler disregards them
        return () => {
            if (!requested) {
                requested = true;
                requestAnimationFrame(() => {
                    requested = false;
                    handler();
                });
            }
        };
    }
    return handler;
}
